/* eslint-disable no-undef */
import $ from 'jquery';
import qs from 'qs';
import user from '../plugins/user'
import device from '../plugins/device'

let token = user.user ? user.user.t : null;

export default {
    setToken(t) {
        token = t;
    },
    getUrl(url) {
        if (token) {
            if (url.indexOf('?') > 0) {
                url += '&t=' + encodeURIComponent(token) + '&d=' + device.device;
            } else {
                url += '?t=' + encodeURIComponent(token) + '&d=' + device.device;
            }
        }
        return config.host + url;
    },
    handle(p) {
        return new Promise((resolve, reject) => {
            if (window.blockUI) {
                window.blockUI();
            }
            p.then(res => {
                if (res.Success) {
                    resolve(res.Result);
                } else {
                    reject(res)
                }
            })
                .catch(function (err) {
                    console.log(err);
                    reject(err)
                }).always(function () {
                    window.unblockUI();
                });
        });
    },
    get(url, data) {
        if (!data) {
            return this.handle($.get(this.getUrl(url)));
        } else {
            return this.handle($.get(this.getUrl(url) + qs.stringify(url)));
        }
    },
    post(url, data) {
        return this.handle($.ajax({
            type: "POST",
            url: this.getUrl(url),
            data: JSON.stringify(data),
            contentType: "application/json"
        }));
    },
    multipartPost(url, data) {
        url = this.getUrl(url);
        var fdata = new FormData();
        for (var key in data) {
            fdata.append(key, data[key]);
        }
        return $.ajax({
            type: "POST",
            url: url,
            contentType: false,
            processData: false,
            data: fdata
        });
    },
    put(url, data) {
        return this.handle($.ajax({
            type: "PUT",
            url: this.getUrl(url),
            data: JSON.stringify(data),
            contentType: "application/json"
        }));
    },
    del(url) {
        return this.handle($.ajax({
            type: "DELETE",
            url: this.getUrl(url),
        }));
    },
    hasToken() {
        return token != null && token != undefined && token != "";
    },

    getDashboard() {
        return this.get('/api/dashboard');
    },
    getDashboardLast() {
        return this.get('/api/dashboard/last');
    },
    getWorkParameters() {
        return this.get('/api/datahistory');
    },
    searchDataHistory(s, e, c, k) {
        var url = '/api/datahistory/search?v=1';
        if (s) {
            url += '&s=' + s;
        }
        if (e) {
            url += '&e=' + e;
        }
        if (c) {
            url += '&c=' + c;
        }
        if (k) {
            url += '&k=' + k;
        }
        return this.get(url);
    },
    searchMaintenHistory(s, e, p) {
        var url = '/api/maintenhistory/search?v=1';
        if (s) {
            url += '&s=' + s;
        }
        if (e) {
            url += '&e=' + e;
        }
        if (p) {
            url += '&p=' + p;
        }
        return this.get(url);
    },
    getMaintenHistory(id) {
        return this.get('/api/maintenhistory/' + id);
    },
    getKPI() {
        return this.get('/api/kpi');
    },
    // getErrorCodes() {
    //     return this.get('/api/errorreport');
    // },
    getErrorReport(addr) {
        return this.get('/api/errorreport/filter?addr=' + encodeURIComponent(addr));
    },
    searchErrorReport(s, e) {
        return this.get('/api/errorreport/search?s=' + s + '&e=' + e);
    },
    getDevices() {
        return this.get('/api/device');
    },
    getThisDevice() {
        return this.get('/api/device/this');
    },
    getDevice(id) {
        if (!id) {
            id = device.device;
        }
        return this.get('/api/device/' + id);
    },
    getErrorCodes() {
        return this.get('/api/errorcodes');
    },
    getManual() {
        return this.get('/api/manual');
    },
    getCostAnalysis() {
        return this.get('/api/costanalysis');
    },
    getCostAnalysisData(time) {
        return this.get('/api/costanalysis/' + encodeURIComponent(time));
    },
    getRoles() {
        return this.get('/api/account/roles');
    },
    createRole(role) {
        return this.put('/api/account/roles', role);
    },
    updateRole(role) {
        return this.post('/api/account/roles', role);
    },
    deleteRole(id) {
        return this.del('/api/account/role/' + id);
    },
    getAccounts() {
        return this.get('/api/account/accounts');
    },
    createAccount(account) {
        return this.put('/api/account/accounts', account);
    },
    updateAccount(account) {
        return this.post('/api/account/accounts', account);
    },
    deleteAccount(id) {
        return this.del('/api/account/account/' + id);
    },
    getMaintenNotifys() {
        return this.get('/api/maintennotify');
    },
    getMaintenNotify(id) {
        return this.get('/api/maintennotify/' + id);
    },
    createMaintenNotify(data) {
        return this.put('/api/maintennotify', data);
    },
    updateMaintenNotify(data) {
        return this.post('/api/maintennotify', data);
    },
    deleteMaintenNotify(id) {
        return this.del('/api/maintennotify/' + id);
    },

    getConfig(id) {
        return this.get('/api/config/' + id);
    },
    createConfig(data) {
        return this.put('/api/config', data);
    },
    updateConfig(data) {
        return this.post('/api/config', data);
    },
    getCurrentMaintenNotify() {
        return this.get('/api/maintennotify/notify');
    },
    getNotifyHistory() {
        return this.get('/api/devicestatushistory')
    },
    setupToken(data){
        return this.post('/api/push', data);
    },
    getSetting() {
        return this.get('/api/user/setting')
    },
    updateSetting(data) {
        return this.post('/api/user/setting', data)
    },
    changePassword(data) {
        return this.post('/api/user/change/password', data)
    },
}